/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

/**
 * The values in this object correspond to the possible values that the
 * {@link planName} property may have.
 */
export const PLAN_NAMES = Object.freeze({
  DEV_ONLY_PREMIUM: 'dev_only-premium',
  LITE: 'lite',
  STANDARD: 'standard',
  PLUS_TRIAL: 'plus_trial',
  PLUS: 'plus',
  PREMIUM: 'premium',
  PREMIUM_USERBASED: 'premium_userbased',
  ENTERPRISE: 'enterprise',
  ENTERPRISE_ISOLATED: 'enterprisedataisolation'
});

/**
 * These are the display names for the different plans, where the key is the
 * value returned by the {@link planName} property (i.e., the values specified
 * in {@link PLAN_NAMES}), and the value is English-only because plan names are
 * not translated.
 *
 * There must be an entry in this object for every entry in {@link PLAN_NAMES}.
 */
export const PLAN_TITLES = Object.freeze({
  [PLAN_NAMES.LITE]: 'Lite',
  [PLAN_NAMES.STANDARD]: 'Standard',
  [PLAN_NAMES.PLUS_TRIAL]: 'Trial',
  [PLAN_NAMES.PLUS]: 'Plus',
  [PLAN_NAMES.PREMIUM]: 'Premium',
  [PLAN_NAMES.PREMIUM_USERBASED]: 'Premium User Based',
  [PLAN_NAMES.ENTERPRISE]: 'Enterprise',
  [PLAN_NAMES.ENTERPRISE_ISOLATED]: 'Enterprise with Isolation'
});

/**
 * This object states whether a particular plan is eligible for upgrade.
 * If a plan is not present, it is not eligible for upgrade.
 */
export const PLAN_UPGRADE = Object.freeze({
  [PLAN_NAMES.LITE]: true,
  [PLAN_NAMES.STANDARD]: true,
  [PLAN_NAMES.PLUS_TRIAL]: true,
  [PLAN_NAMES.PLUS]: true
});
